<circ-loader [isLoading]="loading">
  <div class="row">
    <div class="col-sm-4 p-sm-3">
        <h4>{{ 'menu.nav.action.startMultipleCirculations.text' | i18n}} <help-link [target]="helpTarget"></help-link></h4>
    </div>
    <div class="col-sm text-sm-right p-sm-3">
        <ece-btn-start
          (click)="onStartAllClicked()"
          [title]="'startMultiple.startButton.description' | i18n"
          [text]="'startMultiple.startButton.title' | i18n"
          [disabled]="disableStart"></ece-btn-start>
    </div>
  </div>
  <circ-grid [data]="circulation$ | async" [showOutcome]="false" [enableSelect]="true" (selectionChanged)="onSelectionChanged($event)"></circ-grid>
</circ-loader>
